var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressDetailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 20,
    fill: "#F0EFEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1121 85C59.7376 84.6366 59.2949 84.3201 59.0012 83.9011C56.0645 79.6937 53.1064 75.4991 50.2463 71.2361C47.8841 67.7129 45.8199 64.01 44.4026 59.9822C43.5173 57.468 42.9597 54.8897 43.0023 52.2002C43.1257 44.6491 48.2757 37.8548 55.5027 35.7297C65.0748 32.9119 74.9193 38.5047 77.4475 48.198C78.4136 51.8923 78.0391 55.5182 76.8942 59.1014C75.6429 63.0137 73.7531 66.6311 71.5101 70.0389C68.9054 73.9983 66.1601 77.8679 63.4787 81.776C62.9935 82.4858 62.5339 83.217 62.0061 83.8968C61.6911 84.3073 61.2655 84.6323 60.891 84.9957C60.6314 85 60.3717 85 60.1121 85ZM60.4909 80.908C60.576 80.8097 60.6228 80.7669 60.6569 80.7156C63.3425 76.8246 66.0793 72.9721 68.6968 69.0341C70.91 65.7032 72.8168 62.1885 74.0724 58.3574C75.0215 55.4541 75.4428 52.4952 74.7533 49.4679C72.6508 40.2279 62.968 35.3962 54.3663 39.2829C48.5651 41.9083 45.0921 48.4161 46.0795 54.7528C46.5009 57.4637 47.4202 60.0035 48.5906 62.4621C50.5272 66.5285 53.0085 70.257 55.575 73.9384C57.1881 76.2517 58.8267 78.5521 60.4909 80.908Z",
    fill: "#071523"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5462 43.7811C65.36 43.7982 69.2714 47.7619 69.2544 52.6149C69.2373 57.4509 65.2876 61.3804 60.4611 61.3633C55.6474 61.3462 51.7359 57.3782 51.753 52.5294C51.77 47.6935 55.7155 43.764 60.5462 43.7811ZM60.5037 46.71C57.2945 46.71 54.6642 49.3525 54.6685 52.5807C54.6727 55.7833 57.2945 58.4215 60.4781 58.43C63.6915 58.4386 66.3304 55.8047 66.3346 52.5807C66.3389 49.3568 63.7128 46.71 60.5037 46.71Z",
    fill: "#071523"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressDetailIcon);
export default __webpack_public_path__ + "static/media/address-detail-icon.445e7c2790a2e9696e24e7acf860306c.svg";
export { ForwardRef as ReactComponent };